export default {
  Integrations: {
    header: {
      add_integration: 'Add integration',
      integrations: 'Integrations',
    },
    list: {
      integration: 'Integration',
      status: 'Status',
    },
    list_item: {
      details: 'Details',
      fieldview: 'Fieldview',
      google_calendar: 'Google Calendar',
      leaf_agriculture: 'NDVI',
      active: 'Active',
      inactive: 'Inactive',
      disabled_active_integration:
        "Integration can't be manually disabled at this time. Please contact Support.",
      disabled_inactive_integration:
        "Integration can't be manually enabled at this time. Please contact Support.",
    },
    add_modal: {
      title: 'Add an integration',
      action: 'Add',
      description:
        'To make the integration, select this option and add it, along with other desired integrations',
      google_calendar_warning_info:
        'Applications from all your accounts and farms that you create will appear in your Google account calendar, no matter where you access it.',
      successful_authorization: 'Google Calendar authorization successful.',
      integrations_added: 'Integrations successfully added',
    },
    google_calendar_details: {
      title: 'Connect your account with Google Calendar',
      infos:
        'With this integration, your user will be associated with Google Calendar. If you want Digifarmz to stop notifying you about your applications, simply deactivate the integration whenever you want',
    },
    fieldview_details: {
      title: 'Connect your account with Climate FieldView',
      infos:
        'With this integration, we will bring the following information to you',
      fields: 'Fields',
      farms: 'Farms',
    },
    leaf_agriculture_details: {
      title: 'Connect your farms with NDVI',
      infos:
        'NDVI (Normalized Difference Vegetation Index) is an agricultural, environmental or vegetation cover monitoring tool. It helps identify the health of your plantation through satellite images, which will be displayed for your farms and fields.',
    },
    empty_state_details: {
      title: 'Select one or more integrations',
      text: 'Control which integrations you want to have for your user/account',
    },
    integration_details_modal: {
      fieldview: 'Fieldview integration details',
      google_calendar: 'Google Calendar integration details',
      leaf_agriculture: 'NDVI integration details',
    },
  },
}
